import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
};

export const title: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
  color: (p) => p.palette.common.black,
  fontWeight: 400,
};

export const check: SxStyle = {
  '& .MuiSwitch-switchBase': {
    '&.Mui-checked + .MuiSwitch-track': {
      backgroundColor: (p) => p.palette.grey[400],
    },
  },
  '& .MuiSwitch-track': {
    backgroundColor: (p) => p.palette.primary[500],
  },
};
